import { ClientItem, ReplyWithAttachmentSuggestion } from 'owa-mail-store';
import { SmartDocOption } from 'owa-mail-smart-pill-features';
import { action } from 'satcheljs';

// Ideally we would just call lazyReplyToMessage and pass in the cloudy attachment under the 'attachmentFiles' parameter.
// Unfortunately that doesn't work -- eventually we will call createAttachments with shouldShare: false, when we need shouldShare: true.
// createAttachments only uses shouldShare: true if the cloudy file already exists in the user's mailbox. Therefore we must call it manually.
export default action('createMessageWithAttachmentAction', function(
    item: ClientItem,
    attachment: ReplyWithAttachmentSuggestion,
    option: SmartDocOption
) {
    return {
        item: item,
        attachment: attachment,
        option: option,
    };
});
